import React from 'react';
import { useTranslation } from 'react-i18next';
import type { AbsenceApplication } from '@/components/AbsenceApplication/types';
import { Calendar } from '@/components/Icons/Calendar';
import { ChevronRightFilled } from '@/components/Icons/ChevronRightFilled';
import { countDaysInclusive, formatDateRange } from '@/utils/date';
import { BULLET_SYMBOL } from '@/utils/text';

interface Props {
  application: AbsenceApplication;
  onClick: (id: number) => void;
}

export const AbsenceHistoryItem: React.FC<Props> = ({
  application,
  onClick,
}) => {
  const { t } = useTranslation();
  const { from, to } = application.absencePeriod;
  const periodText = formatDateRange(from, to);
  const daysCount = countDaysInclusive(from, to);

  return (
    <button
      type="button"
      onClick={() => onClick(application.id)}
      className="flex h-16 w-full shrink-0 cursor-pointer items-center rounded-xl bg-card px-4 py-3 text-left shadow-card transition-colors hover:bg-hover active:bg-on-primary-surface"
    >
      <span className="flex size-8 shrink-0 items-center justify-center rounded-full bg-info-surface text-primary">
        <Calendar />
      </span>
      <div className="ml-3 flex min-w-0 flex-1 flex-col">
        <span className="text-subhead-14 truncate text-foreground">
          {periodText}
        </span>
        <span className="text-body-13 mt-0.5 truncate text-muted-foreground md:text-caption-12">
          {t('absenceHistory.days', { count: daysCount })}
          {application.isCanceled && (
            <>
              {` ${BULLET_SYMBOL} `}
              <span className="text-destructive">
                {t('absenceHistory.canceled')}
              </span>
            </>
          )}
        </span>
      </div>
      <span className="ml-2 flex size-4 shrink-0 items-center justify-center text-subtle-foreground">
        <ChevronRightFilled />
      </span>
    </button>
  );
};
